export const trackSearchTab = tabName => `tab:${tabName}`;
export const search = () => "action:search";

// -- Modals
export const trackPassengerModal = isOpen => (isOpen ? `modal:passengers:open` : null);
export const trackPromoModal = isOpen => (isOpen ? `modal:promo:open` : null);


// -- Stations
export const trackStationFrom = station =>
  station ? `station-from:${serialiseStation(station)}` : null;
export const trackStationTo = station =>
  station ? `station-to:${serialiseStation(station)}` : null;
export const trackStationsSwap = () => "swap-stations";

// -- Geolocation
export const trackGeolocationStart = () => `geolocation:start`;
export const trackGeolocationFound = () => `geolocation:found`;
export const trackGeolocationError = () => `geolocation:error`;

// -- Via / Avoid
export const trackViaAvoid = value => (value != null ? `via-avoid:enabled:${value}` : null);
export const trackViaAvoidType = type => (type ? `via-avoid:type:${type}` : null);
export const trackViaAvoidStation = station =>
  station ? `via-avoid:${serialiseStation(station)}` : null;

// -- Dates
export const trackFromDate = date =>
  date ? `date-from:${date.timeType}:${date.format("yyyy-MM-dd HH:mm")}` : null;
export const trackToDate = date =>
  date ? `date-to:${date.timeType}:${date.format("yyyy-MM-dd HH:mm")}` : null;

// -- Passengers
export const trackAdults = num => `adults:${num}`;
export const trackChildren = num => `children:${num}`;
export const trackRailcards = railcards => {
  const pairs = railcards?.map?.(railcard => `(${railcard.railcardCode}x${railcard.quantity})`);
  return pairs?.length ? `railcards:${pairs.join(":")}` : null;
};

// -- Ticket misc
export const trackTicketType = type => `ticket-type:${type}`;

// -- Season tickets
export const trackSeasonStartDate = date => `season:start:${date?.format?.("yyyy-MM-dd")}`;
export const trackSeasonFlexi = isFlexi => `season:length:is-flexi:${isFlexi}`;
export const trackSeasonWeekly = isWeekly => `season:length:is-weekly:${isWeekly}`;
export const trackSeasonMonthly = isMonthly => `season:length:is-monthly:${isMonthly}`;
export const trackSeasonAnnual = isAnnual => `season:length:is-annual:${isAnnual}`;
export const trackSeasonCustom = isCustom => `season:length:is-custom:${isCustom}`;
export const trackSeasonCustomLength = customLength =>
  customLength
    ? `season:length:custom:years=${customLength.years}:months=${customLength.months}:days=${customLength.days}`
    : null;
export const trackSeasonPassenger = passengerType => `season:passenger:${passengerType}`;
export const trackSeasonRailcard = hasRailcard => `season:railcard:${hasRailcard}`;
export const trackJCPRailcard = hasJCPRailcard => `season:jcp-railcard:${hasJCPRailcard}`;

// -- Other Tickets
export const trackOtherTicketType = ticketType => `other-tickets:type:${ticketType}`;
export const trackSmartCarnetStartDate = date => `smart-carnet:start:${date?.format?.("yyyy-MM-dd")}`;
export const trackRoversStartDate = date => `rovers:start:${date?.format?.("yyyy-MM-dd")}`;
export const trackRoversType = type => `rovers:type:${type}`;
export const trackRoversAdults = num => `rovers:${trackAdults(num)}`;
export const trackRoversChildren = num => `rovers:${trackChildren(num)}`;
export const trackRoversRailcards = railcards => {
  const tracking = trackRailcards(railcards);
  return tracking ? `rovers:${tracking}` : null;
};
export const trackDaySaveStartDate = date => `daysave:start:${date?.format?.("yyyy-MM-dd")}`;
export const trackDaySaveAdults = num => `daysave:${trackAdults(num)}`;
export const trackDaySaveChildren = num => `daysave:${trackChildren(num)}`;

// -- Favourites
export const trackFavouritesLoginIntent = () => "favourites:login:intent";
export const trackFavouritesSelectFavouriteIntent = () => "favourites:select-favourite:intent";
export const trackFavouritesSelectFavouriteComplete = id => `favourites:select-favourite:complete:${id}`;
export const trackFavouritesRemoveFavourite = () => "favourites:remove-favourite";
export const trackFavouritesDateChange = date => `favourites:date-change:${date?.format?.("yyyy-MM-dd")}`;
export const trackFavouritesDeliveryChange = () => "favourites:delivery-change";
export const trackFavouritesSubmitDeliveryOptions = () => "favourites:submit-delivery-options";
export const trackFavouritesSubmitPaymentDetails = () => "favourites:submit-payment-details";

// Helpers
function serialiseStation(station) {
  return station ? `${station.nlc}:${station.name}` : null;
}
